import { IBreadcrumbItem, PanelType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import {
  IconButton,
  iconButtonStylesNoBG,
  IPageHeaderProps,
  IPanelProps,
  PageHeader,
  pageHeaderStylesSecondary,
  Panel,
  useClassNames,
} from '@h2oai/ui-kit';
import { useEffect } from 'react';

import { Feature, FeatureSet } from '../../featurestore/gen/ai/h2o/featurestore/api/v1/CoreService.pb';
import { ContentsTitle, defaultPanelWidth } from '../../featurestore/models';
import { EditFeature } from '../EditFeature/EditFeature';
import {
  editFeaturePanelStylesDefault,
  IEditFeaturePanelClassNames,
  IEditFeaturePanelStyles,
} from './EditFeaturePanel.styles';

const getBreadcrumbItems = (featureName = ''): IBreadcrumbItem[] => {
  return [
    { text: featureName, key: featureName },
    {
      text: ContentsTitle.editFeature,
      key: ContentsTitle.editFeature,
      isCurrentItem: true,
    },
  ];
};

interface IEditFeaturePanelProps {
  projectId?: string;
  featureSetVersion?: string;
  feature?: Feature;
  show: boolean;
  onDismiss: (
    ev?: KeyboardEvent | React.SyntheticEvent<HTMLElement, Event> | undefined,
    updatedFeatureSet?: FeatureSet,
    updatedFeature?: Feature
  ) => void;
}

export const EditFeaturePanel = ({ featureSetVersion = '', feature = {}, show, onDismiss }: IEditFeaturePanelProps) => {
  const [isOpen, { setTrue: open, setFalse: close }] = useBoolean(false);
  const panelProps: IPanelProps = {
    type: PanelType.custom,
    customWidth: defaultPanelWidth,
    isOpen,
    onDismiss,
    isFooterAtBottom: true,
    hasCloseButton: false,
  };

  const pageHeaderProps: IPageHeaderProps = {
    pageTitle: ContentsTitle.editFeature,
    styles: pageHeaderStylesSecondary,
    breadcrumbProps: {
      items: getBreadcrumbItems(feature.name),
    },
    actions: <IconButton styles={iconButtonStylesNoBG} iconName="Clear" onClick={() => onDismiss()} />,
  };

  useEffect(() => {
    if (show) {
      open();
    } else {
      close();
    }
  }, [show]);
  const classNames = useClassNames<IEditFeaturePanelStyles, IEditFeaturePanelClassNames>(
    'EditFeaturePanel',
    editFeaturePanelStylesDefault
  );
  return (
    <Panel {...panelProps}>
      <div className={classNames.root}>
        <PageHeader {...pageHeaderProps} />
        <EditFeature
          featureSetVersion={featureSetVersion}
          feature={feature}
          onSave={(updatedFeatureSet, updatedFeature) => onDismiss(undefined, updatedFeatureSet, updatedFeature)}
          onCancel={onDismiss}
        />
      </div>
    </Panel>
  );
};
